<template>
<div>


<section class="hero">
  <div class="hero-body">
<img src="@/assets/house1.jpg" class="pic" />
    <h1>
      Welcome, Cookie Finders! 
    </h1>
    <p class="subtitle">
       You’re looking at the Juliette Gordon Low (Gingerbread) Birthplace, which we’ve relocated* from Savannah, Georgia, to #GirlScoutCentral!
<br/><br/>
New York’s Girl Scout Cookie season is coming up, so to celebrate the launch of the new Adventurefuls™ cookie, we’ve created a Cookie Finder game just for you.  
<br/><br/>
If you look carefully, you’ll see we’ve hidden a bunch of mini Adventurefuls™ cookies around the house. 
<br/><br/>
Hint - They look like this: 

    </p>
       <img src="@/assets/cookies.jpg" />

<p class="subtitle">
  Find the correct number of cookies on each side for a fun surprise! 
<br/><br/>
(*And don’t worry! The real Juliette Gordon Low Birthplace is still standing in Savannah. You should go visit the next time you’re in Georgia!)
</p>

          <h2>Let’s get finding!</h2>
          <p >
              Click one of the links below to start.
            </p>
          <div class="x">
          <a @click="link('Left')">Left</a> - 
            <a @click="link('Front')">Front</a> -
            <a @click="link('Right')">Right</a> 
          </div>
        </div>
        <div class="foot"><a href="https://www.engineerofjoy.com" target="_blank" >engineerofjoy.com</a></div>
   
</section>


  </div>
   
</template>

<script>


export default {
  name: "Home",
  props: {

  },
  data() {
    return {
        
    };
  },
  methods:{
    link(id){
      console.log(id);
      this.$emit('change_page',id) 
    },
    getData() {
      
    },

  },

};
</script>
